/** Разделы, скрытые в налоговом режиме (директор/админ). Остаются врачи, услуги, отчёты, приём, пациенты. */

export const TAX_HIDDEN_ADMIN_PATHS = [
  '/dashboard',
  '/finance',
  '/payments',
  '/attendance',
  '/feedback-inbox',
  '/settings',
  '/templates',
];

export function userUsesTaxView(user) {
  if (!user) return false;
  const canToggle = Boolean(user.isDirector || user.isAdmin || user.role === 'director' || user.role === 'admin');
  if (!canToggle) return false;
  const mode = user.accountingViewMode || user.accounting_view_mode || 'internal';
  return mode === 'tax';
}

export function isRouteHiddenInTaxView(path) {
  if (!path) return false;
  const base = path.split('/:')[0];
  return TAX_HIDDEN_ADMIN_PATHS.includes(base);
}
